// 表示在庫の取得（ChatBan #47）。
//
// リード文の「数量を在庫数に変更して…」の「在庫数」を出すための数字。
// **お客様がページ上で見ている在庫表示と同じ数字**を出す。
//
// 商品ページの在庫表示（.stockInfo）は、wuStorefront の /api/stock-check（Issue #31。
// 2026-09-10 までは OppSites の /StockCheck/Index）が返す HTML を差し込んだもの。data-stock 属性に、表示用の丸め
// （在庫表示切切捨数 → 在庫加算数 → 在庫表示上限。OppSites の
// Views/StockCheck/Index.cshtml）を通した後の数字が入っている。
// 生の在庫ではなくこれを使う理由: リード文が指すのは「表示されている在庫数量」で、
// 丸め設定のある商品では生の在庫と表示が食い違う（例: 生18,200 → 表示18,000）。
//
// 同じ HTML を自分でも取りに行けるので（CORS は `*`）、
//   1. ページ内に .stockInfo が既にあればそれを読む（商品ページ。追加の通信なし）
//   2. 無ければ StockCheck を直接取得する（page/2522 などフォーム単独のページ）
// の順で引く。
//
// ★引けないのは普通のこと（Is在庫非表示・PickupInfo/StockProduct 未設定などは
//   StockCheck が空を返す）。エラーにせず、「確認中」のような後から出てくる
//   期待を持たせる表示もせず、**引けたときだけ静かに足す**。

// ★絶対URLで書くこと（店のページから見れば別オリジン）
const STOCK_CHECK_URL = 'https://front.workup-system.com/api/stock-check'

export interface DisplayStock {
  /** 表示用に丸めた後の在庫数（data-stock の値） */
  num: number
  /** 「12,000 枚在庫があります。」の単位部分。取れなければ空文字 */
  unit: string
  /** 在庫表示上限に張り付いているか（本文が「以上」の意味で出しているか）
   *  ※ data-stock からは判別できないため、本文に上限どおりの数字が出ている前提で
   *    「◯◯以上」とは表示しない。上限設定は本番4件のみ */
}

function parseFromElement(el: Element): DisplayStock | null {
  const raw = el.getAttribute('data-stock')
  if (raw == null || raw === '') return null
  const num = parseInt(raw.replace(/[^\d]/g, ''), 10)
  // 0 は「在庫切れ」の印（StockCheck 側が num<=1 を 0 に落とす）。
  // 在庫切れの商品に「現在の在庫数：0枚」を足してもリード文と噛み合わないので出さない。
  if (isNaN(num) || num <= 0) return null
  const m = (el.textContent ?? '').match(/[\d,]+\s*(\S{1,6})在庫があります/)
  return { num, unit: m ? m[1] : '' }
}

/** ページ内の .stockInfo（ProductDetails.js が差し込んだもの）から読む。無ければ null */
export function readStockFromDom(): DisplayStock | null {
  const el = document.querySelector('.stockInfo')
  return el ? parseFromElement(el) : null
}

/** /api/stock-check を直接取得して読む。引けなければ null（エラーも null） */
export async function fetchDisplayStock(siteInfoId: number, productCode: number): Promise<DisplayStock | null> {
  try {
    const r = await fetch(`${STOCK_CHECK_URL}?productCode=${productCode}&siteInfoId=${siteInfoId}`, { cache: 'no-store' })
    if (!r.ok) return null
    const html = await r.text()
    const doc = new DOMParser().parseFromString(html, 'text/html')
    const el = doc.querySelector('.stockInfo')
    return el ? parseFromElement(el) : null
  } catch {
    return null
  }
}
